import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, CircularProgress } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PlanningProvider } from './context/PlanningContext';
import Sidebar from './components/Sidebar';
import PianificazionePage from './pages/PianificazionePage';
import ProgettiPage from './pages/ProgettiPage';
import RisorsePage from './pages/RisorsePage';
import DashboardPage from './pages/DashboardPage';
import EconomicsPage from './pages/EconomicsPage';
import CapacityPlanningPage from './pages/CapacityPlanningPage';
import CapacityPlanningV2Page from './pages/CapacityPlanningV2Page';
import CapacityPlanningV2DettaglioPage from './pages/CapacityPlanningV2DettaglioPage';
import LoginPage from './pages/LoginPage';
import StrutturePage from './pages/StrutturePage';
import UtentiPage from './pages/UtentiPage';
import PermessiPage from './pages/PermessiPage';
import AboutPage from './pages/AboutPage';
import FigureProfessionaliPage from './pages/FigureProfessionaliPage';
import SkillsPage from './pages/SkillsPage';
import SyncProgettiPage from './pages/SyncProgettiPage';
import SyncClientiPage from './pages/SyncClientiPage';
import SyncRendicontazioniPage from './pages/SyncRendicontazioniPage';
import GruppiProgettiPage from './pages/GruppiProgettiPage';
import PianificazioneVistaPage from './pages/PianificazioneVistaPage';
import PMDashboardPage from './pages/PMDashboardPage';
import PMProgettoDetailPage from './pages/PMProgettoDetailPage';
import InvestimentiPage from './pages/InvestimentiPage';

const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} />;
  }

  return (
    <PlanningProvider>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/pianificazione" element={<PianificazionePage />} />
            <Route path="/pianificazione/gruppi-progetti" element={<GruppiProgettiPage />} />
            <Route path="/pianificazione/vista" element={<PianificazioneVistaPage />} />
            <Route path="/reportistica/dashboard" element={<DashboardPage />} />
            <Route path="/reportistica/economics" element={<EconomicsPage />} />
            <Route path="/reportistica/capacity-planning" element={<CapacityPlanningPage />} />
            <Route path="/reportistica/capacity-planning-v2" element={<CapacityPlanningV2Page />} />
            <Route path="/reportistica/capacity-planning-v2/:anno/:mese" element={<CapacityPlanningV2DettaglioPage />} />
            <Route path="/anagrafiche/progetti" element={<ProgettiPage />} />
            <Route path="/anagrafiche/risorse" element={<RisorsePage />} />
            <Route path="/anagrafiche/strutture" element={<StrutturePage />} />
            <Route path="/anagrafiche/figure-professionali" element={<FigureProfessionaliPage />} />
            <Route path="/anagrafiche/skills" element={<SkillsPage />} />
            <Route path="/anagrafiche/utenti" element={<UtentiPage />} />
            <Route path="/anagrafiche/permessi" element={<PermessiPage />} />
            <Route path="/admin/sync-progetti" element={<SyncProgettiPage />} />
            <Route path="/admin/sync-clienti" element={<SyncClientiPage />} />
            <Route path="/admin/sync-rendicontazioni" element={<SyncRendicontazioniPage />} />
            <Route path="/pm-dashboard" element={<PMDashboardPage />} />
            <Route path="/pm-dashboard/progetti/:id" element={<PMProgettoDetailPage />} />
            <Route path="/analytics/investimenti" element={<InvestimentiPage />} />
            <Route path="/info" element={<AboutPage />} />
          </Routes>
        </Box>
      </Box>
    </PlanningProvider>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;
